module.exports = __webpack_public_path__ + "media/images/cc-100-1c1e5b43d644db336919a93aeec11011.png";